import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TerminosComponent } from './terminos/terminos.component'


import { PipeModule } from '../pipes/pipe.module';
import { PreventaPage } from './preventa/preventa.page';
import { CartComponent } from './cart/cart.component';
import { SearchComponent } from './search/search.component';
import { FlagsComponent } from './flags/flags.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        PipeModule],
    declarations: [
        TerminosComponent,
        PreventaPage,
        CartComponent,
        SearchComponent,
        FlagsComponent
    ],
    exports: [
        TerminosComponent,
        CartComponent,
        SearchComponent,
        FlagsComponent
    ]
})
export class ComponentsModule { }
